import React, { useCallback, useEffect, useState } from 'react';
import { providersAPI } from '../../api/traceability';
import { errorMessage } from '../../lib/evaluationIntegrity';
import { rows, PROVIDER_STATUS } from '../../lib/traceability';
import Providers from './Providers';

export default function ProviderSelector({ eventId, requirement, value = [], disabled, onChange }) {
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');
  const [creating, setCreating] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const load = useCallback(async () => {
    if (!eventId) return;
    setLoaded(false);
    try {
      setItems(rows((await providersAPI.forEvent(eventId)).data));
      setError('');
      setLoaded(true);
    } catch (err) {
      setError(errorMessage(err, 'No se pudieron cargar los proveedores del evento'));
    }
  }, [eventId]);
  useEffect(() => { load(); }, [load]);
  if (!eventId) return <p>No se requiere proveedor en una evaluación sin evento.</p>;
  const eligible = items.filter((item) => requirement.service_types.includes(
    item.provider?.service_type || item.service_type
  ));
  return <div className="space-y-2 border p-3 rounded">
    <fieldset disabled={disabled || !loaded}><legend>Proveedor del evento</legend>
      {eligible.map((item) => <label key={item.id} className="block">
        <input type="checkbox" checked={value.includes(item.id)} onChange={(e) => {
          onChange(e.target.checked ? [...value, item.id] : value.filter((id) => id !== item.id));
        }} /> {item.provider?.trade_name || item.trade_name} · {item.service_date}
        {' · '}{PROVIDER_STATUS[item.status] || item.status}
        {['cancelado', 'no_se_presento'].includes(item.status) && (
          <strong className="block text-amber-800">Advertencia: este proveedor no prestó el servicio.</strong>
        )}
      </label>)}
      {!eligible.length && <p>No hay asignaciones del tipo requerido.</p>}
      {loaded && value.filter((id) => !eligible.some((item) => item.id === id)).map((id) => <p key={id}>
        Asignación no disponible: {id}
        <button type="button" onClick={() => onChange(value.filter((valueId) => valueId !== id))}>Quitar</button>
      </p>)}
      <button type="button" onClick={() => setCreating(!creating)}>+ Nuevo proveedor</button>
    </fieldset>
    {error && <p role="alert">{error} <button type="button" onClick={load}>Reintentar</button></p>}
    {creating && !disabled && <Providers eventId={eventId} onChanged={() => { load(); setCreating(false); }} />}
  </div>;
}
